import SvgIcon from "./SvgIcon";

export default function TableTennisIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M20.53 12.303a4.001 4.001 0 11-4.848 5.932c-2.043 1.03-4.328.98-6.422.086-.607-.26-1.188-.15-1.502.163L5.05 21.192a2 2 0 01-2.828 0L.807 19.778a2 2 0 010-2.828l2.709-2.709c.313-.313.423-.894.163-1.502-1.21-2.83-.873-6.011 1.587-8.471 1.648-1.648 3.828-2.9 6.171-3.2 2.382-.304 4.864.387 6.986 2.51 2.122 2.12 2.813 4.603 2.509 6.985a9.195 9.195 0 01-.401 1.74zm-8.839-9.25c-1.816.232-3.607 1.225-5.011 2.63-.903.902-1.423 1.919-1.605 2.978l8.265 8.264a5.165 5.165 0 001.673-.601 4 4 0 013.49-4.293c.219-.564.37-1.142.445-1.722.227-1.777-.262-3.64-1.94-5.318-1.677-1.677-3.54-2.166-5.317-1.939zm-1.608 13.444l-4.58-4.58.015.037c.491 1.148.449 2.665-.588 3.702l-2.708 2.708 1.414 1.414 2.708-2.708c1.037-1.037 2.553-1.08 3.702-.589l.037.016zM19 14a2 2 0 100 4 2 2 0 000-4z"
        fill={color}
      />
    </SvgIcon>
  )
}
